import { Component } from '@angular/core';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { IEventAction } from 'src/app/@amiga-pyme/table-actions/components/ami-table-actions/ami-table-actions.interface';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { ProductToWarehouseSelectionComponent } from '../../purchases/quick-purchase/product-to-warehouse-selection/product-to-warehouse-selection.component';
import { STATUS_TRANSFER } from '../transfer.interface';
import { TransferService } from '../transfer.service';
import { TransferPendingService } from './transfers-pending.service';
import { getTagColor } from '../../../../../helpers/tag-color.helpers';

@Component({
  templateUrl: './transfers-pending.component.html',
  selector: 'pg-transfers-pending'
})
export class TransfersPendingComponent extends TableActionsTemplate {
  idDocument: number;
  confirmSettings = {};

  constructor(
    private transfersPending: TransferPendingService,
    private transfersManagementService: TransferService
  ) {
    super('', transfersPending);
  }

  ngOnInit() {
    this.table.settings = {
      title: 'Traslados Pendientes',
      columns: [
        { header: 'N° de documento', field: 'numberDocument' },
        { header: 'Sucursal de origen', field: 'branchStoreName' },
        { header: 'Sucursal de destino', field: 'branchStoreReceptionName' },
        { header: 'Estado', field: 'statusTransfer', tag: 'tagStatus' }
      ]
    };

    this.table.actions = [
      {
        name: 'see-details',
        icon: 'pi pi-eye',
        class: 'p-button-rounded p-button-primary',
        pTooltip: 'Ver detalles'
      },
      {
        name: 'accept-transfer',
        icon: 'pi pi-check',
        class: 'p-button-rounded p-button-success',
        pTooltip: 'Aceptar traslado'
      },
      {
        name: 'deny_transfer',
        icon: 'pi pi-times',
        class: 'p-button-rounded p-button-danger',
        pTooltip: 'Rechazar traslado'
      }
    ];

    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.transfersPending
      .getData$()
      .subscribe((data) => {
        data = data.map((item) => {
          item.tagStatusColor = getTagColor(item.statusTransfer);
          return item;
        });
        this.table.data = data;
      });
  }

  async onReciveAction(event: IEventAction) {
    if (event) {
      const { data, action } = event;
      if (action === 'see-details') {
        this.idDocument = data.id;
      } else if (action === 'accept-transfer') {
        this.confirmSettings = {
          message: 'ACEPTAR TRASLADO',
          action: 'accept-transfer',
          data
        };
      } else if (action === 'deny_transfer') {
        this.confirmSettings = {
          message: 'RECHAZAR TRASLADO',
          action: 'deny_transfer',
          data
        };
      }
    }
  }

  async actionConfirmed(event) {
    const { action, data } = event;

    const idDocument = data.id;
    let message;
    let status;

    if (action === 'accept-transfer') {
      message = 'Aceptando el traslado...';
      status = STATUS_TRANSFER.ACEPTADO;
    } else if (action === 'deny_transfer') {
      message = 'Rechazando el traslado...';
      status = STATUS_TRANSFER.ANULADO;
    }

    const fieldsToUpdate = {
      status: status
    };

    this.message = { message: message };

    this.message = await this.transfersManagementService.update(
      idDocument,
      fieldsToUpdate
    );

    const statusHttp = this.message.status;

    if (statusHttp === 200) {
      setTimeout(() => {
        this.message = undefined;
      }, 1500);
    }
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
